import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

/**
 * F5 / Ctrl+R / Ctrl+Shift+R → recarrega o app. No NW.js os atalhos
 * nativos podem estar desabilitados; este handler garante que o usuário
 * possa atualizar sem precisar fechar/reabrir o programa após um release.
 *  - F5            → reload normal
 *  - Ctrl+R        → reload normal
 *  - Ctrl+Shift+R  → reload forçando descarte de cache
 *  - F12           → abre DevTools (quando disponível pelo NW.js)
 */
function recarregarApp(forcado: boolean) {
  try {
    const nw = (window as unknown as { nw?: { Window?: { get?: () => { reload: () => void; reloadIgnoringCache: () => void; showDevTools?: () => void } } } }).nw;
    const janela = nw?.Window?.get?.();
    if (janela) {
      if (forcado && typeof janela.reloadIgnoringCache === 'function') {
        janela.reloadIgnoringCache();
      } else {
        janela.reload();
      }
      return;
    }
  } catch {
    // segue para fallback
  }
  // Fallback browser comum
  window.location.reload();
}

window.addEventListener('keydown', (e) => {
  // F5 → recarrega SEM cache (pega versão nova após release)
  if (e.key === 'F5') {
    e.preventDefault();
    recarregarApp(true);
    return;
  }
  // Ctrl+R / Ctrl+Shift+R → idem
  if (e.ctrlKey && (e.key === 'r' || e.key === 'R')) {
    e.preventDefault();
    recarregarApp(true);
    return;
  }
  // F12 → DevTools (apenas NW.js)
  if (e.key === 'F12') {
    try {
      const nw = (window as unknown as { nw?: { Window?: { get?: () => { showDevTools?: () => void } } } }).nw;
      const janela = nw?.Window?.get?.();
      if (janela && typeof janela.showDevTools === 'function') {
        e.preventDefault();
        janela.showDevTools();
      }
    } catch {
      // ignora se NW.js não estiver disponível
    }
  }
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
